import { Accordion, Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

export function DiscussionGroup2({ state, handleChange }) {
	const { t } = useTranslation()

	return (
		<Accordion defaultActiveKey={['discussionmemo-1']} flush alwaysOpen>
			<Accordion.Item key="discussionmemo-1" eventKey="discussionmemo-1">
				<Accordion.Header>{t('Memo', 'Muistio')}</Accordion.Header>
				<Accordion.Body>
					<Row>
						<Form.Group as={Col} xl={10} className="position-relative" controlId="discussionMemo">
							<Form.Label>{t('OpenDiscussion', 'Avoin keskustelu')}</Form.Label>
							<Form.Control
								as="textarea"
								rows="10"
								defaultValue={state.discussionMemo}
								onChange={handleChange}
								disabled={state.discussionStatus === 'DONE'}
							/>
						</Form.Group>
					</Row>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion>
	)
}
